<app-widget titleT="FIDUCIARY.cockpit.creditor-widget.title"
    [navigateLink]="['/', 'customer-spaces', customerSpaceId, 'fiduciary', 'creditor']">

    <div class="slot-action-button">
        <app-scan-document-button [customerSpaceId]="customerSpaceId" inbox="creditor" [iconOnly]="true" />

        <div *ngIf="!isDragAndDropOverlayVisible">
            <app-widget-file-upload label="" tooltip="{{ 'file-upload.creditor-upload' | translate }}"
                (filesUploaded)="uploadFile($event)" />
        </div>

        <div *ngIf="isDragAndDropOverlayVisible" class="drag-and-drop">
            <app-drag-and-drop-info></app-drag-and-drop-info>
        </div>
    </div>
</app-widget>